import React, {useState, useEffect, useRef} from 'react'
import { Input, InputNumber, Form, Spin } from 'antd'

import MaskedInput from 'antd-mask-input'

import './float.scss'
import { SpinnerIco } from "../../../modules/CustomIcons";
import { useTranslation } from 'react-i18next';

const formatNumber = (value) =>{
  value += '';
  const list = value.split('.');
  const prefix = list[0].charAt(0) === '-' ? '-' : '';
  let num = prefix ? list[0].slice(1) : list[0];
  let result = '';
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return `${prefix}${result}${list[1] ? `.${list[1]}` : ''}`;
}

const InputFieldLogin = (props: any) => {
  const {t} = useTranslation()
  const max_length=props.maxLength || 140;
  const input_type=props.type || 'text';
  const input_name=props.name || '';
  const input_id=`input_${input_name}`;

  const [focus, setFocus] = useState(false)
  const [value, setValue] = useState(props.value || '');
  const [symbolCount, setSymbolCount] = useState(max_length);
  const [maxRows, setMaxRows] = useState<any>(5);
  const [visibleAutoComplete, setVisibleAutoComplete] = useState(false)
  const { label } = props;


  const updateValue = (get_value) => {
    let value_1= props.allowLatin ? get_value?.replace(/[а-яА-ЯЁё]+/, '').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '') : get_value?.replace(/[^a-zA-Z0-9., ]+/,'')?.replace(/[а-яА-ЯЁё]+/, '');

    let value_=props.allowAllSymboll ? get_value :value_1;

      setValue(old_value => value_);

      if (props.form){

        props.form.setFieldsValue(
            {
              [input_name]: value_
            }
        );
      }
  }

  useEffect(() => {
    updateValue(props.value);

    if (props.maxLength){
      setSymbolCount(props.maxLength)
    }

  }, [props.value, props.maxLength, props.disabled, props.mask, props.placeholder]);

  const labelClass = focus || props.value ? 'label label-float' : 'label';

  const hideAutoComplete = (row) => {
    props.filterRowClick(row);

    setVisibleAutoComplete(old_status => false);

  }

  const handleInputChange = (e) => {
    if (props.handleInputChange){
      props.handleInputChange(e);
    }

    if (props.autoComplete){
      setVisibleAutoComplete(old_status => value >= 2);
    }

    if (props.isNumeric){

      const value = e.target?.value;
      const reg = /^-?\d*(\.\d*)?$/;

      if ( (!isNaN(value) && reg.test(value)) || value === '' || value === '-' ) {

        updateValue(value);
      }

    }else{
      updateValue(e.target.value);
    }

  };


  const handleInputKeyUp = (e) => {
    let value=e.target.value;

    if(props.onKeyUp){
      props.onKeyUp();
    }

    if (props.showCount){
      let value_length=value.length;
      let calc_row=value_length >= 210 ? 100 : 5;

      setSymbolCount(old_value => max_length - value_length);

      setMaxRows(old_value => calc_row);


    }
  }

  const onBlur = (e) => {

    if (props.onBlur){
      props.onBlur(e);
    }

    const { value} = e.target;
    let valueTemp = value;



    if (props.isNumeric){
      const {onBlur, onChange } = e;

      if (value.charAt(value.length - 1) === '.' ||  value === '-') {
        valueTemp = value.slice(0, -1);
      }

      handleInputChange(valueTemp.replace(/0*(\d+)/, '$1'));
    }


  };

  const onKeyPress = (e) => {

    if (props.onKeyPress){
      props.onKeyPress();
    }

    const value=e.target.value;
    const key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    const regex = new RegExp(/^[^!-\\/:-@\\[-`{-~]+$/);
    const is_russian=/[а-яА-ЯЁё]/.test(value);
    const letterNumber = /[A-Z0-9]+$/i;
    const isUpperCase = (string) => /^[A-Z]*$/.test(string)




    if (props.onlyLetter){

      if (!props.allowAllSymboll && (!regex.test(key) && !isUpperCase(key)) || is_russian ) {

        e.preventDefault();
        return false;

      }
    }

    if (props.onlyLetterAndNumber){

      if (!e.key.match(letterNumber) || is_russian ) {

        e.preventDefault();
        return false;

      }

    }

    if (max_length && value.length > max_length-1){
      e.preventDefault();
    }

    if (props.isNumeric){
      let regex = /[0-9]|\./;

      if (e.which==101 || !regex.test(key)){
        e.preventDefault();
      }

    }


    updateValue(e.target.value);

  }

  const onPaste = (e) => {
    //e.preventDefault();

  }

  const input_component = (
      <>
        <Input

            className={props.className}
            readOnly={props.readOnly || false}
            name={input_name}
            ref={props.inputRef}
            maxLength={max_length}
            // autoSize={{ minRows: 3, maxRows: maxRows }}
            placeholder={props.placeholder}
            prefix={props.prefix || false}
            suffix={props.suffix || false}
            allowClear={props.allowClear || false}
            defaultValue={props.defaultValue || ''}
            size = {props.size}
            onChange={handleInputChange}
            onKeyUp={handleInputKeyUp}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            onPaste={onPaste}
            value={value}
            disabled={props.disabled || false}
            type={input_type}
            id={input_id}
        />

        {
            props.showCount && <div className={'show_input_counter'}><span>{symbolCount}</span>/{max_length}</div>
        }
      </>
  );

  let validate_message=props.message || '';

  if (props.required && !props.message){
    validate_message=t("newTransfer.requiredField");
  }



  return (
    <>
      <Form.Item
        name={input_name}
        label={props.labelItem}
        labelCol={props.labelCol}
        wrapperCol={props.wrapperCol}
        className={props.className}
        validateTrigger={['onChange', 'onBlur']}
        rules={[
            {
              required: props.required || false,
              message : validate_message,
              /*pattern: props.onlyEngLetter ? new RegExp(/[A-Z]+$/g) : undefined,*/
            }
        ]}
      >
        <div
          className="float-label input-field"
          onBlur={() => setFocus(false)}
          onFocus={() => setFocus(true)}
          style={{width: props.width}}
        >
          {
            props.type == 'phoneNumber' || props.type=='mask' ? (
            <MaskedInput
                name={input_name}
                maxLength={max_length}
                mask={props?.mask}
                placeholder={props?.placeholder}
                prefix={props?.prefix}
                suffix={props?.suffix}
                onChange={handleInputChange}
                onBlur={onBlur}
                value={value}
            />

          ) : (props.hasLoading) ? <Spin className={'custom_spin'} indicator={<SpinnerIco />} >{input_component}</Spin> : input_component

          }
          <label className={props.type == 'phoneNumber' ? 'label label-float' : labelClass}>{label}</label>

          {
            props.autoComplete && value >= 2 && visibleAutoComplete &&
              <div className={'full flex direction_column autocomplete_box '} >

                {
                  props.options?.length == 0 && value?.length >= 2 ? <p className={'full flex justify_center code_not_found'} >{t("notification.notFoundInfo")}</p> :

                      <ul className={'full flex direction_column autocomplete_list scroll_y'} >
                        {
                          props.options?.map((row, index) => {
                            return (
                                <li onClick={() => hideAutoComplete(row) }  key={`filter_item_${index}`} >
                                  { row.CODE ? row.CODE : row.code }
                                </li>
                            )
                          })
                        }
                      </ul>
                }

              </div>
          }
        </div>


        {
            props.showMessage && <span className={'form_error_span'} >{props.message}</span>
        }
      </Form.Item>
    </>
  )
}

export default InputFieldLogin
